module.exports = __webpack_public_path__ + "static/media/evenbreeze-1.2963adda.jpg";